module.exports = __webpack_public_path__ + "static/Richa_Thames-45ed2f9f99c4b89fc38649b7ac207c93.jpeg";